import { useEffect, useState } from 'react';

type Options = IntersectionObserverInit & {
	freezeOnceVisible?: boolean;
};

function useIntersectionObserver(ref, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false }: Options) {
	const [entry, setEntry] = useState<IntersectionObserverEntry>();
	const frozen = entry?.isIntersecting && freezeOnceVisible;

	const updateEntry = ([entry]: IntersectionObserverEntry[]) => {
		setEntry(entry);
	};

	useEffect(() => {
		const element = ref;
		const hasIOSupport = !!window.IntersectionObserver;

		if (!hasIOSupport || frozen || !element) return;

		const params: IntersectionObserverInit = { threshold, root, rootMargin };
		const observer = new IntersectionObserver(updateEntry, params);
		if (!observer) return;

		observer.observe(element);

		return () => observer.disconnect();
	}, [frozen, ref, root, rootMargin, JSON.stringify(threshold)]);

	return entry;
}

export default useIntersectionObserver;
